import githubDark from '@shikijs/themes/github-dark';

import { createOnigurumaEngine } from 'shiki/engine/oniguruma';

import javascript from '@shikijs/langs/javascript';
import applescript from '@shikijs/langs/applescript';
import css from '@shikijs/langs/css';
import bash from '@shikijs/langs/bash';
import vb from '@shikijs/langs/vb';
import c from '@shikijs/langs/c';
import lua from '@shikijs/langs/lua';
import { createHighlighter } from 'shiki';

export const highlighter = createHighlighter({
  themes: [githubDark],
  langs: [javascript, applescript, bash, css, vb, c, lua],
  langAlias: {
    vba: 'vb',
  },
  engine: createOnigurumaEngine(import('shiki/wasm')),
});

export const supportedLanguages = [
  'javascript',
  'applescript',
  'bash',
  'css',
  'vba',
  'c',
  'lua',
] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const isSupportedLanguage = (lang: string): lang is SupportedLanguage => {
  return supportedLanguages.includes(lang as SupportedLanguage);
};

export async function highlight(code: string, lang: SupportedLanguage) {
  const out = (await highlighter).codeToHtml(code, { lang, theme: githubDark });
  return out;
}
